export const SVG_TEMPLATES = {
  theme1: {
    top: (color: string, secondryColor: string) => `<svg xmlns="http://www.w3.org/2000/svg" width="1123" height="1050" viewBox="0 0 1123 1050" fill="none">
<g clip-path="url(#clip0_813_980)">
<mask id="mask0_813_980" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="1123" height="1050">
<path d="M0 0H1123V1050H0V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_813_980)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1060.37 390.558C1194.11 390.558 1354.75 395.53 1396.25 378.077L1487.48 244.336C1508.5 244.336 1528.66 252.439 1543.53 266.863C1558.39 281.286 1566.74 300.849 1566.74 321.247V628.881C1566.74 671.358 1531.26 705.792 1487.48 705.792H1139.63C1095.85 705.792 1060.37 671.358 1060.37 628.881V390.558Z" stroke="${secondryColor}" stroke-width="45" stroke-miterlimit="800"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1104.79 398.729C1104.79 355.286 1517.69 444.67 1561.14 444.67L1528.66 161.875C1549.53 161.875 1569.53 170.162 1584.29 184.914C1599.04 199.666 1607.33 219.674 1607.33 240.536V555.17C1607.33 598.613 1572.11 633.83 1528.66 633.83H1183.45C1140 633.83 1104.79 598.613 1104.79 555.17V476.949V398.729Z" stroke="${color}" stroke-width="45" stroke-miterlimit="800"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M985.34 -6.16047C985.34 -49.6036 1020.56 -84.8213 1064 -84.8213H1409.22C1430.08 -84.8213 1450.09 -76.5338 1464.84 -61.7821C1479.59 -47.0303 1487.88 -27.0226 1487.88 -6.16047V308.473C1487.88 351.917 1452.66 387.134 1409.22 387.134H1064C1020.56 387.134 985.34 351.917 985.34 308.473V-6.16047Z" stroke="${secondryColor}" stroke-width="45" stroke-miterlimit="800"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1030.42 -63.1312C1030.42 -106.574 1065.64 -141.792 1109.08 -141.792H1454.3C1475.16 -141.792 1495.17 -133.505 1509.92 -118.753C1524.67 -104.001 1532.96 -83.9933 1532.96 -63.1312V251.503C1532.96 294.946 1497.74 330.163 1454.3 330.163H1109.08C1065.64 330.163 1030.42 294.946 1030.42 251.503V-63.1312Z" stroke="${color}" stroke-width="45" stroke-miterlimit="800"/>
</g>
</g>
</svg>`,
     bottom: (color: string, secondryColor: string) => `<svg xmlns="http://www.w3.org/2000/svg" width="1123" height="1050" viewBox="0 0 1123 1050" fill="none">
<g clip-path="url(#clip0_814_1008)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M-397.812 830.9C-397.812 794.633 -368.449 765.232 -332.228 765.232H-44.3971C-27.003 765.232 -10.3213 772.151 1.97818 784.466C14.2777 796.781 21.1875 813.484 21.1875 830.9V1093.56C21.1875 1129.83 -8.17576 1159.23 -44.3971 1159.23H-332.228C-368.449 1159.23 -397.812 1129.83 -397.812 1093.56L-397.812 830.9Z" stroke="${secondryColor}" stroke-width="45" stroke-miterlimit="800"/>
<path d="M-28.7852 668.5C-3.47578 668.5 20.7736 678.608 38.6338 696.562C56.4898 714.513 66.5 738.833 66.5 764.168V1056.83C66.4999 1109.56 23.9504 1152.5 -28.7852 1152.5H-348.215C-400.95 1152.5 -443.5 1109.56 -443.5 1056.83V764.168C-443.5 711.444 -400.95 668.5 -348.215 668.5H-28.7852Z" stroke="${color}" stroke-width="45" stroke-miterlimit="800"/>
</g>
</svg>`,
    content: (color: string, secondryColor: string) => `<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="90" viewBox="0 0 1200 90" fill="none">
<rect y="20" width="1200" height="70" fill="${secondryColor}"/>
<path d="M0 0H232L244.5 10L257 20H0V0Z" fill="${color}"/>
</svg>`
  },
  theme2: {
    top: (color: string, secondryColor: string) => `<svg xmlns="http://www.w3.org/2000/svg" width="1076" height="703" viewBox="0 0 1076 703" fill="none">
<g clip-path="url(#clip0_51_33)">
<path d="M284.5 212.5L82 341.5L284.5 468.5L494 344L284.5 212.5Z" fill="${color}"/>
<path d="M0 654V396.5L82 341.5L284.5 468.5L0 654Z" fill="#F2F2F2"/>
<path d="M579 652L284 468.5L1075.5 -1V349L579 652Z" fill="${secondryColor}"/>
</g>
</svg>`,
    bottom: () => null, // Theme 2 doesn't have a bottom SVG
    content: (color: string, secondryColor: string) => `<svg xmlns="http://www.w3.org/2000/svg" width="1050" height="83" viewBox="0 0 1050 83" fill="none">
<g clip-path="url(#clip0_48_87)">
<path d="M273 41H0V83H257L273 41Z" fill="${secondryColor}"/>
<path d="M276 42H1056V78H262L276 42Z" fill="${color}"/>
</g>
</svg>`
  },
  theme3:{
    top:() => null,
    bottom: () => null,
    content:(color:string,secondryColor:string)=>`<svg xmlns="http://www.w3.org/2000/svg" width="1050" height="110" viewBox="0 0 1050 110" fill="none">
<g clip-path="url(#clip0_78_30)">
<path d="M193 21H-100V83H157L193 21Z" fill="${color}"/>
<path d="M397 83H1230V21H433L397 83Z" fill="${color}"/>
</g>
<defs>
<clipPath id="clip0_78_30">
<rect width="1050" height="110" fill="white"/>
</clipPath>
</defs>
</svg>`
  }
};